import { type PortalSettings, type FieldValues, type ColumnSettingsFieldValue } from '@gorilla/portal-shared/src/schemas';
import { ColumnSettingsFieldDescriptor, SectionDescriptor } from '@gorilla/portal-shared/src/types';
import { ColumnSettingsClientsBoardField } from './ColumnSettingsClientsBoardField';
import { ColumnSettingsBoardSourceField } from './ColumnSettingsBoardSourceField';
import { type Board as BoardType } from '@gorilla/common/src/lib/monday-api/api';

type ColumnSettingsFieldProps = {
  value: ColumnSettingsFieldValue;
  fieldDescriptor: ColumnSettingsFieldDescriptor;
  sectionDescriptor: SectionDescriptor;
  portalSettings: PortalSettings;
  sectionFieldValues: FieldValues;
  clientBoard: BoardType;
  onChange: (value: ColumnSettingsFieldValue) => void;
  clientBoardSubitemsBoardId: number | null;
  screenMode: 'small' | 'medium' | 'large';
  isOpen: boolean;
};

export function ColumnSettingsField({
  value,
  fieldDescriptor,
  portalSettings,
  onChange,
  sectionDescriptor,
  sectionFieldValues,
  clientBoard,
  clientBoardSubitemsBoardId,
  screenMode,
  isOpen,
}: ColumnSettingsFieldProps) {
  if (fieldDescriptor.sourceType === 'clients-board') {
    if (!clientBoard) {
      return null;
    }

    return (
      <ColumnSettingsClientsBoardField
        value={value}
        clientBoard={clientBoard}
        onChange={onChange}
        fieldDescriptor={fieldDescriptor}
        screenMode={screenMode}
        isOpen={isOpen}
      />
    );
  } else if (fieldDescriptor.sourceType === 'board-source') {
    return (
      <ColumnSettingsBoardSourceField
        value={value}
        fieldDescriptor={fieldDescriptor}
        portalSettings={portalSettings}
        onChange={onChange}
        sectionDescriptor={sectionDescriptor}
        sectionFieldValues={sectionFieldValues}
        clientBoardSubitemsBoardId={clientBoardSubitemsBoardId}
        screenMode={screenMode}
        isOpen={isOpen}
      />
    );
  }

  return null;
}
